/** @file GIZMO_PALETTE: the gizmo's Babylon colours (axes, centre, hover), built once from VIEWPORT_COLORS. */
import { Color3 } from '@babylonjs/core/Maths/math.color.js';
import { VIEWPORT_COLORS } from './viewportColors';

const axis = [VIEWPORT_COLORS.axisX, VIEWPORT_COLORS.axisY, VIEWPORT_COLORS.axisZ].map((h) => Color3.FromHexString(h));

/**
 * `handle[i]`: the colour of handle `i` (0..2 X red, Y green, Z blue; 3 the centre, light grey; 4..6 a plane, by its
 * normal); `hover` replaces it on the hovered or dragged handle; `silhouette` is the rotate trackball's white outline.
 * Shared, never mutated.
 */
export const GIZMO_PALETTE: { handle: readonly Color3[]; hover: Color3; silhouette: Color3 } = {
  handle: [...axis, Color3.FromHexString(VIEWPORT_COLORS.centre), ...axis], hover: Color3.FromHexString(VIEWPORT_COLORS.hover), silhouette: Color3.White(),
};
